export const ROLE_NAME_MAX_LENGTH = 64;
export const ROLE_NAME_MIN_LENGTH = 2;
export const ROLE_NAME_PATTERN = /^[a-z0-9._]+$/;

export const normalizeRoleName = (raw) => {
    const lower = (raw || "").toLowerCase();
    const allowed = lower.replace(/[^a-z0-9._]/g, "_");
    return allowed.replace(/_+/g, "_");
};

export const validateRoleName = (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) return "Role name is required";
    if (trimmed.length < ROLE_NAME_MIN_LENGTH) return `Role name must be at least ${ROLE_NAME_MIN_LENGTH} characters`;
    if (trimmed.length > ROLE_NAME_MAX_LENGTH) return `Role name must be at most ${ROLE_NAME_MAX_LENGTH} characters`;
    if (!ROLE_NAME_PATTERN.test(trimmed)) return "Only lowercase letters, numbers, dots and underscores allowed";
    return null;
};

export const USER_STATUS_OPTIONS = [
    { value: "approved", label: "Approved" },
    { value: "pending", label: "Pending" },
    { value: "rejected", label: "Rejected" },
    { value: "suspended", label: "Suspended" },
];

export const INTERNAL_AGENCY_FILTER = "internal";

export const userFiltersDefaultState = { search: "", status: "", role: "", agency: "" };
